import Urls from "../../constants/urls";
import lockerRoom1 from './imgs/Cam1.jpg';
import lockerRoom2 from './imgs/Cam2.jpg';
import lockerRoom3 from './imgs/Cam3.jpg';

export const shopifyData = {
    domain: "dirtysocks-ltd.myshopify.com",
    token: "3b5881ce6d9fa84499494e54e993e643",
    productIds: ["7012428120234"],
};

export const lockerRoom1Hotspot = [
    {
        type: "arrow",
        yPosition: -25,
        zPosition: -46,
        xPosition: -28,
        xRotation: 275,
        yRotation: 90,
        zRotation: 93,
        radius: 6,
        link: Urls.lockerRoom.lockerRoom2.path,
    }
];

export const lockerRoom2Hotspot = [
    {
        type: "arrow",
        yPosition: -25,
        zPosition: 36,
        xPosition: -35,
        xRotation: 275,
        yRotation: 93,
        zRotation: 87,
        radius: 5,
        link: Urls.lockerRoom.lockerRoom1.path,
    },
    {
        type: "spot",
        yPosition: -15,
        zPosition: 0.5,
        xPosition: 50,
        xRotation: 250,
        yRotation: 90,
        zRotation: 180,
        radius: 3,
        link: Urls.lockerRoom.lockerRoom3.path,
    },
    {
        type: "cart",
        xPosition: -1.5,
        yPosition: -5,
        zPosition: -25,
        yRotation: 0,
        radius: 1,
        productId: "7012428120234",
    },
    {
        type: "play",
        xPosition: -5.5,
        yPosition: -5,
        zPosition: -25,
        yRotation: 0,
        radius: 1.45,
        channel: "youtube",
        videoId: "rS7K9VZB6wc",
        linkRotation: 80,
    },
    
];

export const lockerRoom3Hotspot = [
    {
        type: "arrow",
        yPosition: -25,
        zPosition: 36,
        xPosition: -40,
        xRotation: 275,
        yRotation: 93,
        zRotation: -275,
        radius: 4.5,
        link: Urls.lockerRoom.lockerRoom2.path,
    },
];

export const rooms = [
    {
        name: "Locker Room 1",
        img: lockerRoom1,
        route: Urls.lockerRoom.lockerRoom1,
        yRotation: 360,
    },
    {
        name: "Locker Room 2",
        img: lockerRoom2,
        route: Urls.lockerRoom.lockerRoom2,
        yRotation: 90,
    },
    {
        name: "Locker Room 3",
        img: lockerRoom3,
        route: Urls.lockerRoom.lockerRoom3,
        yRotation: 90,
    },
];
